module.exports = __webpack_public_path__ + "static/media/led-matrix.da190d17.svg";